<template>

  <nav
    class="w-full flex items-center justify-between flex-wrap bg-gray-900 p-6"
  >


    <div class="flex items-center flex-shrink-0 text-white mr-6">
      <!-- <img :src="logo" /> -->
      <img width="40px" src="@/assets/logo_navy.png" alt="Octo Digital Logo" />
      <span class="font-semibold text-2xl tracking-tight">Octo.Digital</span>
    </div>
    <div class="block lg:hidden">
      <button
        @click="isOn = !isOn"
        :aria-checked="isOn"
        class="flex items-center px-3 py-2 border rounded text-white border-teal-400 hover:text-white hover:border-white"
      >
        <svg
          class="fill-current h-3 w-3"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <div
      aria-hidden="true"
      :class="isOn ? 'visible' : 'hidden'"
      class="w-full flex-grow lg:flex lg:items-center lg:w-auto"
    >
      <div class="text-lg lg:flex-grow">
        <a
          href="/"
          class="font-medium block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white hover:underline mr-4 "
        >
          <router-link to="/">Home</router-link>
        </a>
        <a
          href="/services"
          class="font-medium block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white hover:underline mr-4"
        >
          <router-link to="/services">Services</router-link>
        </a>
        <a
          href="/data"
          class="font-medium block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white hover:underline mr-4"
        >
          <router-link to="/data">Projects</router-link>
        </a>
      </div>
      <div>
        <a
        href="/contact"
          class="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-4 mr-4 lg:mt-0"
        >
          <router-link to="/contact">Contact Us</router-link>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import logo from "@/assets/logo_navy.png";

export default {
  data: function() {
    return {
      image: logo,
      isOn: false
    };
  }
};
</script>
